import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import config from "../config/memberhubContents.json";
import { useState } from 'react';

function RewardSection(props) {
    const hasVoting = useSelector(state => state.data.hasVoting);
    const [viewAll, setViewAll] = useState(false);
    const shouldBeTransparent = data => {
        return (props.tabSelected === "benefits" && data.max_select_quantity === 0) || isSoldOut(data) || codeAccessed(data) ||
            (props.tabSelected === "voting" && data.results && data.results.total_responses !== undefined);
    }

    const codeAccessed = data => props.tabSelected === "benefits" && data.reference_id === "code_code" &&
        data.redeemed && data.redeemed.codes;
    const isSoldOut = data => props.tabSelected === "benefits" && data.reference_id === "code_code" &&
        !data.redeemed && data.extra_data && data.extra_data.sold_out === "1" && data.max_select_quantity === 0;

    return (
        <div className="section-container section-bottom-margin">
            {(props && props.section && (props.section.title || props.section.subtitle)) && <div className="section-header">
                <div className="section-title">
                    { props.section.title && <p>{props.section.title}</p> }
                </div>
                { props.tabSelected === "voting" && props.section.title === config.votingTitle && props.section.subtitle && <div className="section-subtitle">
                    <p>{hasVoting ? config.shareYourVoiceDescription : config.noActivityDescription}</p>
                </div>}
                { props.section.title !== config.votingTitle && props.section.subtitle &&  <div className="section-subtitle">
                    <p>{props.section.subtitle}</p>
                </div>}
            </div>}
            <div className="reward-card-container">
                {props && props.section && props.section.rewards && props.section.rewards.map((data, index) => {
                    return index < 6 || !props.showViewAll || (props.showViewAll && viewAll) ?
                        <Link
                            id={data.id}
                            key={index}
                            to={{
                                pathname: (props.tabSelected === "benefits" ? `/benefits/${data.id}` : `/voting/${data.id}`),
                                search: window.location.search.includes("cl=1") ? window.location.search : window.location.search + "&cl=1"
                            }}
                            title={data.title} className="reward-card-holder">
                            <div className="reward-card">
                                {shouldBeTransparent(data) &&
                                    <div className="reward-card-tag">
                                        <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 h-6 overflow-hidden rounded border border-white/40">
                                            <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-1 px-2 py-1 bg-black/60">
                                                <p className="flex-grow-0 flex-shrink-0 text-xs font-bold text-center text-white">
                                                    {data.reference_id === "sweepstakes" ? config.entered :
                                                        props.tabSelected === "voting" ? config.completed :
                                                            isSoldOut(data) ? data.extra_data.sold_out_tag ? data.extra_data.sold_out_tag : config.soldout : config.accessed}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex-grow h-[21px] opacity-0 bg-[#c4c4c4]" />
                                    </div>
                                }
                                {props.tabSelected === "benefits" && data.max_select_quantity !== 0 && data.is_new &&
                                    <div className="reward-card-tag">
                                        <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 h-6 overflow-hidden rounded border border-white/40">
                                            <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-1 px-2 py-1 bg-black/60">
                                                <p className="flex-grow-0 flex-shrink-0 text-xs font-bold text-center text-white">
                                                    {config.new}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex-grow h-[21px] opacity-0 bg-[#c4c4c4]" />
                                    </div>
                                }
                                <div className="reward-card-img-container">
                                    <img className="reward-card-img" src={data.image} alt={data.title}
                                        style={{ backgroundImage: data.image, opacity: shouldBeTransparent(data) ? 0.4 : 1 }} />
                                </div>
                                <div className="reward-card-text">{data.title}</div>
                            </div>
                        </Link> : '';
                })}
            </div>
            {!viewAll && props.showViewAll && props.section.rewards.length > 6 &&
                <div className='flex flex-col self-stretch flex-grow-0 flex-shrink-0 w-[323px] view-all-btn' onClick={() => setViewAll(!viewAll)}>
                    View All
                </div>}
        </div>
    );
}

export default RewardSection;
